<app-header></app-header>

<div class="container-xxl">
  <section class="banner d-flex justify-content-center align-items-center text-center">
    <div class="content" data-aos="zoom-in" data-aos-duration="2000">
      <div class="title">
        <span>الأقسام</span>
      </div>
    
      <div class="links">
        <a class="text-decoration-none" routerLink="/home"> الرئيسية </a>
        <span>/</span>
        <a class="text-decoration-none" routerLink="/getAllCategories"> الأقسام </a>
        <span>/ {{ category.Title }}</span>
      </div>
    </div>
  </section>

  <section class="category mt-5 pb-5">
    <div class="container">
      <div class="text-center" data-aos="fade-up" data-aos-duration="2000">
        <div class="title">
          <h2>{{ category.Title }}</h2>
        </div>
        <div class="description">
          <span>{{ category.Description }}</span>
        </div>
      </div>
    </div>
  </section>
  
  <section class="cousres mt-5 pb-5">
    <div class="container">
    <h2 data-aos="fade-left" data-aos-duration="2000">الدورات التدريبية</h2>
    <div class="group" *ngFor="let categoryCourse of categoryCourses">
      <a class="course row mt-5" routerLink="/getCourseById/{{categoryCourse._id}}" data-aos="flip-down" data-aos-duration="2000">

        <div class="course-image col-md-3">
          <img class="img-fluid" src="https://khairokom-uploadfiles.azurewebsites.net/files/{{categoryCourse.image}}">
        </div>
      
          <div class="course-content col-md-9 d-flex align-items-center mt-4">
              <div class="content">
                  <h2 class="title">{{categoryCourse.tittle}}</h2>                    
                  <p class="desc">{{categoryCourse.description}}</p> 
              </div>               
          </div>                        
      </a>  

     </div>
     </div>
  </section>

  
</div>


<!-- <div class="container emp-profile">
  <form method="post">
    <div class="row">      
      <div class="col-md-8">
        <div class="tab-content profile-tab" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <img
              src="https://khairokom-uploadfiles.azurewebsites.net/files/{{
                category.Image
              }}"
              height="200px"
              width="200px"
            />
            <div class="row">
              <div class="col-md-6">
                <label>اســـم القســـم</label>
              </div>
              <div class="col-md-6">
                <p>{{ category.Title }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>وصــــف القســـم</label>
              </div>
              <div class="col-md-6">
                <p>{{ category.Description }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>الصـــورة</label>
              </div>
              <div class="col-md-6">
                <img src="{{ category.Image }}" alt="تحميل الصورة" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>الدورات التدربية</label>
              </div>
              <div *ngFor="let course of categoryCourses">
                <div class="col-md-6">
                  <label>اسم الدورة التدربية</label>
                 </div>
                 <div class="col-md-6">
                   <a routerLink="/getCourseById/course._id">{{course.tittle}}</a>
                  </div>
                  <div class="col-md-6">
                    <label>الصـــورة</label>
                  </div>
                  <div class="col-md-6">
                    <img src="{{ course.Image }}" alt="تحميل الصورة"  width="100px" height="100px"/>
                  </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="profile-work"></div>
      </div>
    </div>
  </form>
</div> -->

<app-footer></app-footer>
